import type { ImportQueueBundle } from '../ru/import-queue';

export const importQueueEn: ImportQueueBundle = {
  status: {
    PENDING: 'Extracting',
    EXTRACTED: 'Extracted',
    IGNORED: 'Ignored',
    IMPORTED: 'Published',
    REJECTED: 'Rejected',
    DUPLICATE: 'Duplicate',
  },
  filters: {
    statusLabel: 'Status',
    any: 'All',
    cityLabel: 'City',
    channelLabel: 'Channel',
    fromLabel: 'From',
    toLabel: 'To',
    reset: 'Reset filters',
  },
  table: {
    headerChannel: 'Channel',
    headerCity: 'City',
    headerPostedAt: 'Posted',
    headerStatus: 'Status',
    headerTitle: 'Title',
    headerConfidence: 'Confidence',
    headerActions: 'Actions',
    emptyTitle: 'Queue is empty',
    emptyDescription: 'Events will show up here after the LLM extracts them from Telegram channel posts.',
    possibleDuplicate: 'possible duplicate',
    open: 'Open',
    loadMore: 'Load more',
  },
  skipReason: {
    lowConfidenceBadge: 'Confidence {{pct}}%',
    lowConfidenceTitle: 'Low LLM confidence',
    lowConfidenceDescription: 'The LLM scored confidence at {{pct}}%, below the {{threshold}}% threshold.',
    lowConfidenceHint: 'Check the extracted fields and publish manually if they are correct.',
    multiDateBadge: 'Multi-date ({{count}})',
    multiDateTitle: 'Multiple dates',
    multiDateDescription: 'The LLM found {{count}} dates for this event.',
    multiDateHint: 'Confirm or edit the date list and publish manually.',
    noDateBadge: 'No date',
    noDateTitle: 'No date',
    noDateDescription: 'The LLM did not extract any date.',
    noDateHint: 'Add a date in the form and publish manually.',
    missingTitleBadge: 'No title',
    missingTitleTitle: 'No title',
    missingTitleDescription: 'The LLM did not extract an event title.',
    missingTitleHint: 'Fill in the title in the form and publish manually.',
  },
  moderation: {
    createEvent: 'Create event',
    publishingEllipsis: 'Publishing…',
    reextract: 'Re-extract',
    reextractSuccess: 'Re-extraction started',
    reextractError: 'Failed to restart',
    ignore: 'Ignore',
    ignoreConfirmAction: 'Ignore',
    ignoreConfirmTitle: 'Ignore this message?',
    ignoreConfirmDescription:
      'The message will disappear from the moderation queue, but stays in the database and will not be reprocessed by the LLM.',
    ignoreSuccess: 'Marked as ignored',
    ignoreError: 'Failed to ignore',
    reject: 'Reject',
    rejectConfirmTitle: 'Reject this message?',
    rejectConfirmDescription: 'The extracted event will not be published. Describe the reason for the audit.',
    rejectNotePlaceholder: 'Rejection reason (opt.)',
    rejectSuccess: 'Rejected',
    rejectError: 'Failed to reject',
    cancel: 'Cancel',
    loadingEllipsis: 'Loading…',
    rejectingEllipsis: 'Rejecting…',
    formNotReady: 'Form is not ready yet',
    invalidFormFields: 'Check the form fields (date, title, categories)',
    eventPublished: 'Event published to the feed',
    publishFailed: 'Failed to publish',
    publishedToFeed: 'Published: {{label}}',
    publishedToFeedGeneric: 'Published to the feed',
    otherSectionLabel: 'Or publish to another feed section',
  },
  feedPublishActions: {
    labelPrefix: 'To {{label}}',
  },
  placeMatch: {
    unlink: 'Unlink',
    searchPlaceholder: 'Search place...',
    notFound: 'Not found',
    selectPlaceholder: 'Select place (opt.)',
    noMatches: 'No matches found.',
    createNew: 'Create new',
  },
  publishForm: {
    organizerBlocked:
      'The organizer is blocked — the post is not published. Unblock them under “Blocked organizers”.',
    cityLabel: 'City',
    selectCity: 'Select city',
    tzHintPrefix: "Time is entered in the city's time zone: ",
    titleLabel: 'Title',
    titlePlaceholder: 'Poetry slam',
    venueLabel: 'Venue',
    venuePlaceholder: 'Bar on Ben Thanh',
    linkPlaceLabel: 'Link to place (opt.)',
    resolvingEllipsis: 'Resolving…',
    resolveFromMap: '📍 Create place from post map link',
    resolveMapHintPrefix: 'Resolves ',
    resolveMapHintLink: 'the map link',
    resolveMapHintSuffix: ' via Google Places and links a Place (uses quota).',
    placeEmptyHint: 'Leave empty and the event will only link to the free-text venue.',
    placeLinkedToast: 'Place linked: {{venueText}}',
    placeResolveError: 'Failed to resolve place from link (check Google Places quota)',
    descriptionLabel: 'Description',
    datesLabel: 'Dates',
    removeDate: 'Remove date',
    addDate: '+ Add date',
    startTimeLabel: 'Start time (opt., shared across all dates)',
    endDateLabel: 'End date (opt.)',
    endTimeLabel: 'End time (opt.)',
    categoriesLabel: 'Categories',
    priceLabel: 'Price, in base units (0 / empty = free)',
    organizerUsernameLabel: "Organizer's Telegram username (opt.)",
    organizerUsernamePlaceholder: '@ada_lovelace',
    coverImageUrlLabel: 'Cover (URL)',
    videoUrlLabel: 'Video (URL)',
    publishNowLabel: 'Publish now (otherwise created as draft)',
    duplicateTitle: 'Possible duplicate',
    duplicateKindEventNews: 'event/news',
    duplicateKindEvent: 'event',
    duplicateSimilarToPrefix: 'Looks similar to an existing ',
    similaritySuffix: ' — {{pct}}% similar',
    confirmAnyway: 'Publish anyway?',
    cancel: 'Cancel',
    publishingEllipsis: 'Publishing…',
    publish: 'Publish',
    eventCreated_one: 'Event created',
    eventCreated_other: 'Created {{count}} events',
  },
  rawPost: {
    openInTelegram: 'Open in Telegram',
    authorTitle: 'Message author — used as the organizer when the post text has none',
    postTextLabel: 'Post text',
    empty: '(empty)',
    mediaLabel: 'Media ({{count}})',
    videoLabel: 'Video',
  },
};
